import React from "react";
import EuropeMap from "../../assets/europe.svg";
import { useTranslation } from "../../context/TranslationContext";

export const RenderMap = () => {
  const { t } = useTranslation();

  return (
    <div className="overflow-hidden flex items-end justify-center relative">
      <h1 className="headline absolute right-1/2 top-1/2 -translate-y-1/2 translate-x-1/2 text-neutral/85 text-center">
        {t("common.inEuropeAndUK")}
      </h1>
      <img className="mx-auto object-bottom w-full" src={EuropeMap} />
    </div>
  );
};
